// Elenco delle pagine dell'app conosciute da DF Academy: usato dal pannello
// admin per scegliere su quale pagina scrivere/aggiornare la guida, senza
// rischiare errori di battitura nel page_key. Il page_key deve corrispondere
// esattamente a quello calcolato da getPageKey() per la rotta reale.
export const KNOWN_PAGES = [
  { page_key: "panoramica", title: "Panoramica" },
  { page_key: "controlli", title: "Controlli di oggi" },
  { page_key: "temperature", title: "Temperature" },
  { page_key: "olio-frittura", title: "Olio di frittura" },
  { page_key: "pulizie", title: "Pulizie e sanificazioni" },
  { page_key: "altri-controlli", title: "Altri controlli HACCP" },
  { page_key: "abbattimento", title: "Abbattimento prodotti (procedura)" },
  { page_key: "prodotti-abbattuti", title: "Prodotti abbattuti (lista)" },
  { page_key: "non-conformita", title: "Non conformità" },
  { page_key: "attrezzature", title: "Attrezzature" },
  { page_key: "ricette", title: "Ricette" },
  { page_key: "ingredienti", title: "Materie prime" },
  { page_key: "lotti", title: "Lotti registrati (lista)" },
  { page_key: "carica-lotti", title: "Carica lotti manuale" },
  { page_key: "fornitori", title: "Fornitori" },
  { page_key: "produzioni", title: "Produzioni create" },
  { page_key: "crea-produzione", title: "Crea produzione" },
  { page_key: "programmazione-produzioni", title: "Programmazione produzioni" },
  { page_key: "etichette-abbattuti", title: "Etichette prodotti abbattuti" },
  { page_key: "etichette", title: "Etichette & QR" },
  { page_key: "report", title: "Report e verbali" },
  { page_key: "libro-ingredienti", title: "Libro degli ingredienti" },
  { page_key: "stampa-qr", title: "Stampa QR code" },
  { page_key: "dati-azienda", title: "Dati azienda" },
  { page_key: "ispezione", title: "Ispezione ASL/NAS" },
  { page_key: "shelf-life", title: "Shelf life (DF Food Safety Expert Engine)" },
  { page_key: "assistenza", title: "Contatta Dottor D" },
];

// Ricava un page_key stabile dal path corrente, indipendente da parametri
// dinamici nell'URL (es. /app/lotti-ricetta/abc123 -> "lotti-ricetta").
export function getPageKey(pathname) {
  const path = pathname.replace(/^\/app\/?/, "");
  if (!path) return "panoramica";
  const segments = path.split("/").filter(Boolean);
  return segments[0];
}
